<template>
  <div class="container">
    <div class="header">
      <span style="color: #333333;font-size: 16px;font-weight: 400;cursor: pointer" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i>返回首页</span>
      <span style="color: #333333;font-weight: 400;font-size: 20px">找回密码</span>
      <span></span>
    </div>
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="userMobile">
          <el-input v-model="form.userMobile" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="form.code" prefix-icon="el-icon-chat-dot-square" placeholder="请输入短信验证码" autocomplete="off">
            <el-button slot="append" @click="getCode">{{ !show ? "随机验证码" : message }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="form.password" prefix-icon="el-icon-lock" placeholder="设置新的登录密码"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="password2">
          <el-input type="password" v-model="form.password2" prefix-icon="el-icon-lock" placeholder="再次确认新的登录密码"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100%;background: #DC2325;color: #fff" @click="found('form')">找回密码</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "index",
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      form: {
        userMobile: "",
        code: "",
        sessionId: "",
        password: "",
        password2: "",
      },
      rules: {
        userMobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        password2: [
          {validator: validatePass2, trigger: 'blur'}
        ]
      },
      message: "",
      show: false
    }
  },
  mounted() {

  },
  methods: {
    getCode() {
      let second = 60;
      const timer = setInterval(() => {
        second--;
        if (second) {
          this.message = `${second}s`;
        } else {
          clearInterval(timer)
          // 手动清除 Toast
          this.show = false
        }
      }, 1000);
      api.send(this.form.userMobile).then(res => {
        this.form.sessionId = res.data
      })
      this.show = !this.show
    },
    found(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          api.found(this.form).then(res => {
            this.$message.success("密码重置成功！")
            this.form = {}
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    margin-top: 20px;
    height: 663px;
    background: #ffffff;

    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px 10px;
      border-bottom: 1px solid #F0F0F0;
    }

    .content {
      width: 370px;
      margin: 50px auto;
    }
  }
</style>
